<template>
	<b-row>
		<b-col
			sm="4"
			md="4"
			lg="4"
			style=" border-right: 2px solid white;"
			v-loading="formLoading"
		>
			<h2 align="center"><b>Ingreso</b></h2>
			<br />

			<div class="d-flex justify-content-center">
				<b-button
					class="btn btn-sm btnClass "
					style="background-color: #660033; color:white"
				>
					Peritos
				</b-button>
				<b-button
					@click="selectOption"
					class="btn   btn-sm btnClass "
					style="background-color:  #ff4da9; color:white"
				>
					Asignación
				</b-button>
			</div>

			<br />
			<div
				v-for="(item, i) in forForm"
				:key="i"
			>
				<b-form-input
					:id="getId(item.state)"
					:state="item.state"
					v-model="schema[item.title]"
					:placeholder="item.title"
				></b-form-input>
				<br />
			</div>

			<div class="d-flex justify-content-center">
				<b-button
					class="btn   btn-lg btnLgClass "
					style=" color:white"
					v-on:click="savePeritosData()"
				>
					Crear Perito
				</b-button>
			</div>
		</b-col>
		<b-col
			sm="8"
			md="8"
			lg="8"
		>
			<h2><b>Peritos</b></h2>
			<b-row>
				<b-col
					sm="6"
					md="6"
					lg="6"
				>
					<b-form-group
						label-for="filter-input"
						label-align-sm="right"
						class="mb-0"
					>
						<b-input-group>
							<b-form-input
								id="filter-input"
								v-model="filter"
								type="search"
								placeholder="Escribe aqui para buscar"
							></b-form-input>

							<b-input-group-append>
								<b-button
									:disabled="!filter"
									@click="filter = ''"
								>
									Limpiar
								</b-button>
							</b-input-group-append>
						</b-input-group>
					</b-form-group>
				</b-col>
			</b-row>
			<br />

			<b-table
				:filter="filter"
				:filter-included-fields="fields"
				responsive
				striped
				hover
				:items="getPeritos"
				:fields="fields"
				v-loading="tableLoading"
			></b-table>
		</b-col>
		<!-- <pre>{{ getPeritos }}</pre> -->
	</b-row>
</template>
<script>
export default {
	name: "asignaciones",
	props: ["selectOption"],
	data() {
		return {
			validationCheck: false,
			filter: null,
			formLoading: false,
			tableLoading: true,
			schema: {},
			fields: ["Nombre", "Contacto", "Telefono", "Correo", "Cobertura"],
			forForm: [
				{
					title: "Nombre",
					state: null
				},
				{
					title: "Contacto",
					state: null
				},
				{
					title: "Teléfono",
					state: null
				},
				{
					title: "Correo",
					state: null
				},
				{
					title: "Cobertura",
					state: null
				}
			]
		};
	},
	mounted() {
		this.fetchPeritosData();
	},
	computed: {
		getPeritos() {
			return this.$store.getters["asignacion/$allPeritos"];
		}
	},
	methods: {
		required(val) {
			if (val === undefined) return false;
			else return val.length > 0;
		},
		fetchPeritosData() {
			this.tableLoading = true;
			this.$store.dispatch("asignacion/fetchPeritosData").then(() => {
				this.tableLoading = false;
			});
		},
		savePeritosData() {
			if (this.dataValidated()) {
				this.formLoading = true;
				this.$store
					.dispatch("asignacion/uploadPeritosData", this.schema)
					.then(() => {
						this.fetchPeritosData();
						this.formLoading = false;
					});
			}
		},
		dataValidated() {
			const array = this.forForm.filter(item => {
				return item.state;
			});
			return array.length === this.forForm.length;
		},
		getId(state) {
			if (state === null) return "input-none";
			else if (state) return "input-valid";
			else return "input-invalid";
		}
	},
	watch: {
		"schema.Nombre"(val) {
			this.forForm[0].state = val.length > 0;
		},
		"schema.Contacto"(val) {
			this.forForm[1].state = val.length > 0;
		},
		"schema.Telefono"(val) {
			this.forForm[2].state = val.length > 0;
		},
		"schema.Correo"(val) {
			this.forForm[3].state = val.length > 0;
		},
		"schema.Cobertura"(val) {
			this.forForm[4].state = val.length > 0;
		}
	}
};
</script>

<style>
	.btnClass {
		width: 100px !important;
	}
	.btnLgClass {
		width: 200px !important;
		background-color: #ff3399;
	}
	.btnLgClass:hover {
		color: #fff;
		background-color: #ff3399;
	}
	.table thead th {
		border-right: 1px solid white;
		vertical-align: bottom;
		background-color: rgb(102, 0, 51);
		color: white;
		border-bottom: 2px solid #e9ecef;
	}
	.table td,
	.table th {
		font-size: 0.8125rem;
		border-right: 1px solid white;
		white-space: nowrap;
	}
</style>
